import axios from 'axios';
import { handleResponseError } from '../handleResponse/handleResponseError';
import { handleResponseSuccess } from '../handleResponse/handleResponseSuccess';
import { headers } from '../headers';

export function GET(url: string, params: any): any {
    const {cancelToken, showErrorNotify, params: requestParams, ...payload} = params;
    const query = payload.query ? payload.query : '';
    const checkPage = query.indexOf('page') !== -1; 

    const header = checkPage ? 'application/ld+json' : 'application/json';
    
    const id = payload.id ? payload.id : '';
    
    const path = id ? `${url}${id}${query}` : `${url}${query}`;

    const h = headers(url, header);

    return axios.get(path, {cancelToken, headers: h, params: requestParams}).then(
        response => {
            return handleResponseSuccess(response);
        },
        e => {
            return handleResponseError(e.response, {showNotify: showErrorNotify});
        }
    );
}
